import { cx } from '@emotion/css';
import React from 'react';

import { Container, FaceButtonColor, FaceButtonSize, FaceButtonIcon } from './styles';
import { Typography } from 'styles';

function getTypoSize(size?: FaceButtonSize) {
  switch (size) {
    case FaceButtonSize.S13_H32:
    case FaceButtonSize.S13_H40:
      return Typography.BUTTON_SMALL;
    case FaceButtonSize.S15_H40:
    case FaceButtonSize.S15_H48:
      return Typography.BUTTON;
    default:
      return null;
  }
}

export interface FaceButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color_type?: FaceButtonColor;
  size_type?: FaceButtonSize;
  icon_type?: FaceButtonIcon;
}

const FaceButton: React.FC<FaceButtonProps> = ({ children, color_type, size_type, icon_type, ...otherProps }) => {
  return (
    <Container colorType={color_type} sizeType={size_type} {...otherProps}>
      {!!icon_type && <figure className={cx('icon', icon_type)} />}
      {children && <span className={cx('text', getTypoSize(size_type))}>{children}</span>}
    </Container>
  );
};

export default FaceButton;

export { FaceButtonColor, FaceButtonSize, FaceButtonIcon };
